module.exports = __webpack_public_path__ + "media/floorplan_black.1f1b7f15.svg";